var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusSuccessIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 1C3.24 1 1 3.24 1 6C1 8.76 3.24 11 6 11C8.76 11 11 8.76 11 6C11 3.24 8.76 1 6 1ZM6 10C3.795 10 2 8.205 2 6C2 3.795 3.795 2 6 2C8.205 2 10 3.795 10 6C10 8.205 8.205 10 6 10ZM7.94 4.145L5 7.085L4.06 6.145C3.96651 6.05151 3.83971 5.99899 3.7075 5.99899C3.57529 5.99899 3.44849 6.05151 3.355 6.145C3.26151 6.23849 3.20899 6.36529 3.20899 6.4975C3.20899 6.62971 3.26151 6.75651 3.355 6.85L4.65 8.145C4.845 8.34 5.16 8.34 5.355 8.145L8.65 4.85C8.69635 4.80374 8.73313 4.7488 8.75822 4.68831C8.78331 4.62783 8.79622 4.56298 8.79622 4.4975C8.79622 4.43202 8.78331 4.36717 8.75822 4.30669C8.73313 4.2462 8.69635 4.19126 8.65 4.145C8.455 3.95 8.135 3.95 7.94 4.145Z",
    fill: "#006644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusSuccessIcon);
export default __webpack_public_path__ + "static/media/StatusSuccessIcon.9fa06944149cbb5435615db655986efe.svg";
export { ForwardRef as ReactComponent };